import { AlertDialog } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import {
	ReactElement,
	useCallback,
	useState
} from "react";

export type UploadAttachmentInProgressDialogProps = {
	onClose(): void;
};

export const UploadAttachmentInProgressDialog = (props: UploadAttachmentInProgressDialogProps): ReactElement => {
	const {
		onClose
	} = props;

	return (
		<AlertDialog
			trackingId="uploading-in-progress-dialog"
			title={localize("_UploadingInProgress")}
			confirmText={localize("_Ok")}
			onClose={onClose}
		>
			{localize("_PleaseWaitUntilUploadFinished")}
		</AlertDialog>
	);
};
UploadAttachmentInProgressDialog.displayName = "UploadAttachmentInProgressDialog";

export function useUploadAttachmentInProgressDialog(): [
	element: ReactElement | null,
	open: () => void
] {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const openHandler = useCallback(
		(): void => {
			setIsOpen(true);
		},
		[]
	);

	const closeHandler = useCallback(
		(): void => {
			setIsOpen(false);
		},
		[]
	);

	const render = (): ReactElement | null => {
		if (!isOpen) {
			return null;
		}

		return (
			<UploadAttachmentInProgressDialog onClose={closeHandler} />
		);
	};

	return [
		render(),
		openHandler
	];
}